import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UatComponent } from './uat.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddUatComponent } from './add-uat/add-uat.component';
import { EditUatComponent } from './edit-uat/edit-uat.component';

@NgModule({
  declarations: [
    UatComponent,
    AddUatComponent,
    EditUatComponent,
  ],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
  exports: [UatComponent],
})
export class UatModule {}
